/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { DetailCheckResultUpgradeComponent } from './detail-check-result-upgrade.component';

@NgModule({
    declarations: [DetailCheckResultUpgradeComponent],
    exports: [DetailCheckResultUpgradeComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
    ],
})
export class DetailCheckResultUpgradeModule { }
